import { useContext } from 'react';
import { InstantSearchServerContext } from '../components/InstantSearchServerContext.js';

function useInstantSearchServerContext() {
    return useContext(InstantSearchServerContext);
}

export { useInstantSearchServerContext };
